var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoogle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.86 6.506a.317.317 0 0 0-.31-.258H8.168a.317.317 0 0 0-.317.317v3.04c0 .174.142.316.317.316h3.624A4.243 4.243 0 0 1 8 12.25a4.27 4.27 0 0 1-3.981-2.76 4.249 4.249 0 0 1 6.229-5.1.317.317 0 0 0 .368-.023l2.489-2.038a.317.317 0 0 0 .002-.488A8.01 8.01 0 0 0 8 0C3.589 0 0 3.589 0 8a7.997 7.997 0 0 0 8 8 8.015 8.015 0 0 0 5.067-1.809 8.023 8.023 0 0 0 2.758-4.52 8.035 8.035 0 0 0 .035-3.165ZM8 .633c1.586 0 3.133.515 4.399 1.457l-2.013 1.648a4.886 4.886 0 0 0-6.84 2.259L1.58 4.389A7.372 7.372 0 0 1 8 .633ZM.633 8c0-1.08.234-2.108.654-3.033l2.026 1.658a4.885 4.885 0 0 0 .037 2.873l-2.012 1.648A7.39 7.39 0 0 1 .633 8Zm14.573 1.538a7.388 7.388 0 0 1-2.398 4.043l-1.966-1.61a4.903 4.903 0 0 0 1.732-2.256.317.317 0 0 0-.297-.427H8.486V6.88h6.796a7.438 7.438 0 0 1-.076 2.657Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff"
  })))));
};
export { SvgGoogle as ReactComponent };